<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Form-->
<div class="MainGrid2Col">
	<label>School Incident Type:</label>
	<select class="form-control" [(ngModel)]="SchoolIncidentTypeID">
		<option *ngFor="let r of lstSchoolIncidentType" [ngValue]="r.SchoolIncidentTypeID">
			{{ r.SchoolIncidentTypeDesc }}
		</option>
	</select>

	<label>Date/Time:</label>
	<div>
		<p-calendar [(ngModel)]="IncidentDate" showIcon="true"></p-calendar>

		<p-calendar [(ngModel)]="IncidentTime" showIcon="true" showTime="true" [timeOnly]="true" hourFormat="12"></p-calendar>
	</div>

	<label>School Incident Comments:</label>
	<textarea class="TextArea" rows="5" [(ngModel)]="Comments"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
